var isPrimitive = function (data) {
    return ['number', 'string', 'boolean'].includes(typeof data);
};
var parseAB = function (_a, command) {
    var a = _a[0], b = _a[1];
    var parsedA = expResolver(a);
    var parsedB = expResolver(b);
    if (isPrimitive(parsedA) && isPrimitive(parsedB)) {
        return command([parsedA, parsedB]);
    }
    return false;
};
// comparison
var equal = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a == b;
}); };
var strictEqual = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a === b;
}); };
var notEqual = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a != b;
}); };
var notStrictEqual = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a !== b;
}); };
var greaterThan = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a > b;
}); };
var greaterThanInclusive = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a >= b;
}); };
var lessThan = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a < b;
}); };
var lessThanInclusive = function (param) { return parseAB(param, function (_a) {
    var a = _a[0], b = _a[1];
    return a <= b;
}); };
// logical
var and = function (expressions) {
    return expressions.reduce(function (previous, expression) { return previous && expResolver(expression); }, true);
};
var or = function (expressions) {
    return expressions.reduce(function (previous, expression) { return previous || expResolver(expression); }, false);
};
var nullish = function (expressions) {
    return expressions.reduce(function (previous, expression) { return previous !== null && previous !== void 0 ? previous : expResolver(expression); }, null);
};
// to bool
var toBool = function (data) { return !!expResolver(data); };
var toBoolInverse = function (data) { return !expResolver(data); };
// inclusion
var includes = function (_a) {
    var a = _a[0], b = _a[1];
    var parsedA = expResolver(a);
    if (Array.isArray(parsedA)) {
        parsedA = parsedA.map(expResolver);
    }
    var parsedB = expResolver(b);
    if (!parsedA || !parsedB || !Object.keys(parsedA).length)
        return false;
    return parsedA.includes(parsedB);
};
var notIncludes = function (data) { return !includes(data); };
var exp = {
    // comparison
    '!=': notEqual,
    '!==': notStrictEqual,
    '==': equal,
    '===': strictEqual,
    '<': lessThan,
    '<=': lessThanInclusive,
    '>': greaterThan,
    '>=': greaterThanInclusive,
    // to bool
    '!': toBoolInverse,
    '!!': toBool,
    // logical
    '&&': and,
    '??': nullish,
    '||': or,
    // inclusion operator
    '!IN': notIncludes,
    IN: includes,
};
var expResolver = function (params) {
    if (params && params instanceof Object && Object.keys(params).length === 1) {
        var _a = Object.entries(params).pop(), operation = _a[0], data = _a[1];
        if (operation && exp[operation]) {
            return expResolver(exp[operation](data));
        }
    }
    return params;
};
export default (function (params) {
    return expResolver(params);
});
//# sourceMappingURL=rave-exp.js.map